module.exports = __webpack_public_path__ + "img/marshallTroop.e828b425.png";